import {
  APP_SETTING_SAVE_LOCALIZATION_CONFIG_BEGIN,
  APP_SETTING_SAVE_LOCALIZATION_CONFIG_SUCCESS,
  APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE,
  APP_SETTING_SAVE_LOCALIZATION_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveLocalizationConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_SAVE_LOCALIZATION_CONFIG_BEGIN,
    });
    const { projectId } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(args.projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_SAVE_LOCALIZATION_CONFIG_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveLocalizationConfigError() {
  return {
    type: APP_SETTING_SAVE_LOCALIZATION_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_SAVE_LOCALIZATION_CONFIG_BEGIN:
      return {
        ...state,
        saveLocalizationConfigPending: true,
        saveLocalizationConfigError: null,
      };

    case APP_SETTING_SAVE_LOCALIZATION_CONFIG_SUCCESS:
      return {
        ...state,
        saveLocalizationConfigPending: false,
        saveLocalizationConfigError: null,
        localization: [...state.localization, action.data],
      };

    case APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE:
      return {
        ...state,
        saveLocalizationConfigPending: false,
        saveLocalizationConfigError: action.data.error,
      };

    case APP_SETTING_SAVE_LOCALIZATION_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        saveLocalizationConfigError: null,
      };

    default:
      return state;
  }
}
